'use memo';

import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { IdpHeader } from './_layout/-components/IdpHeader';
export const Route = createFileRoute('/_staff/idp/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  const matchRoute = useMatchRoute();
  // 作成・編集ステッパーは親の ProductHeader を出さない（Settings 認証と同型）
  const hideIdpHeader = Boolean(matchRoute({
    to: '/idp/access-rules/new'
  })) || Boolean(matchRoute({
    to: '/idp/access-rules/$id'
  })) || Boolean(matchRoute({
    to: '/idp/policies/new'
  })) || Boolean(matchRoute({
    to: '/idp/policies/$id'
  }));
  return <VStack className="gap-0 h-full">
      {!hideIdpHeader ? <IdpHeader /> : null}
      <div className="relative min-h-0 flex-1 overflow-auto bg-neutral-gray-light-2">
        <Outlet />
      </div>
    </VStack>;
}